// Vendor libraries
import { combineReducers } from '@ngrx/store';
// NgRx reducers
import { searchTypes } from './search-types/search-types.reducer';
import { queryInput } from './query-input/query-input.reducer';
import { searchCategoryPageNum } from './search-category-page-num/search-category-page-num.reducer';
export const searchAllParams = combineReducers({
    searchTypes,
    queryInput,
    searchCategoryPageNum,
});
